(function () {
	'use strict';

	angular
		.module('wizard-english-test.configs', []);

	angular
		.module('wizard-english-test.constants', []);

	angular
		.module('wizard-english-test.directives', []);

	angular
		.module('wizard-english-test.services', []);

	angular
		.module('wizard-english-test.routes', []);

	angular
		.module('wizard-english-test.interceptors', []);
}());